import React from 'react'
import Header from "../Header/Header"
import PeopleManagmentMain from './PeopleManagmentMain'


const PeopleManagmentBody = () => {
  return (
    <div>
       <Header title="People Managment" />
       <PeopleManagmentMain />
    </div>
  )
}

export default PeopleManagmentBody
